<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    八卦岭站<br>
站点介绍<br>
6号线八卦岭站位于上步北路和八卦三路交叉口东南侧，沿上步南路呈南北向布置；同7号线八卦岭馆通道换乘。车站为地下三层岛式车站。现状车站周边基本为成熟建成区，车站的北侧是中煤大厦、港彩印刷公司及深圳国际展览中心；南侧是劳动就业大厦；东侧是鹏益花园小区及平安大厦；西南侧为深圳市体育馆。车站设置有E、F、G1、G2共4个出入口，其中G1、G2为预留出入口。该站为地下车站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:22	00:05	6号线	3分24秒	6分20秒<br>
松岗	06:25	23:05	6号线	3分24秒	6分20秒<br>
西丽湖	06:30	23:10	7号线	3分35秒	5分55秒<br>
太安	06:19	23:46	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:21	00:05	6号线	4分45秒	6分钟<br>
松岗	06:25	23:05	6号线	4分45秒	6分钟<br>
西丽湖	06:29	23:10	7号线	4分钟	5分55秒<br>
太安	06:18	23:46	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:21	01:05	6号线	4分45秒	6分钟<br>
松岗	06:25	00:05	6号线	4分45秒	6分钟<br>
西丽湖	06:30	00:10	7号线	4分钟	5分55秒<br>
太安	06:18	00:46	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
八卦一路、八卦二路、鹏益花园、国税局<br><br>
B出入口:<br>
八卦五街、八卦六街、汉富中心<br><br>
D出入口:<br>
岁宝壹品、北环大道、上步北路、泥岗路东侧<br><br>
E出入口:<br>
八卦二路、上步北路、鹏益花园、深圳体育场、城市主场公寓、盛世鹏程花园、劳动就业大厦<br><br>
F出入口:<br>
鹏益花园、平安大厦、八卦三路<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 劳动就业大厦<br>
8路,218路,M156路,N6,N17路(临时停运)<br><br>
D出入口:<br>
公交站名： 八卦岭地铁站②<br>
M152<br><br>
B出入口:<br>
公交站名： 八卦岭地铁站1<br>
323<br><br>
E出入口:<br>
公交站名： 劳动就业大厦<br>
8路,218路,N6路,N17路(临时停运)<br><br>
E出入口:<br>
公交站名： 体育馆东<br>
323路，4路,E10路，E20路，E5路，M165路，M198路，M389路，M584路,N6路，高峰专线33路<br><br>
F出入口:<br>
公交站名： 八卦岭地铁站②<br>
M152路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>